import { Avatar as AntdAvatar } from 'antd'
import styled from 'styled-components'

export const Column = styled.div`
  width: 100%;
  min-height: 851px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`

export const Card = styled.div`
  width: 100%;
  height: 80px;
  background: var(--color-background);
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 9px;
  box-shadow: var(--shadow-box);
`

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--color-border-primary);
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 700;
`

export const Subtitle = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 400;
  margin-top: 2px;
`

export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`

export const NavButton = styled.button`
  width: 152px;
  @media (min-width: 1370px) {
    width: 48%;
  }
  height: 52px;
  background: var(--color-background);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  color: var(--color-text-primary);

  font-size: 20px;
  font-weight: 700;

  cursor: pointer;
  box-shadow: var(--shadow-box);
  transition: 0.2s;

  &:hover:not(:disabled) {
    background: var(--color-background);
  }

  &:disabled {
    color: var(--color-disabled);
    border-color: var(--color-disabled);
    cursor: not-allowed;
  }
`
export const DoctorProfile = styled(AntdAvatar)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  overflow: hidden;
  border: 1px solid var(--color-border-primary);
`
export const LoadingContainer = styled.div`
  width: 100%;
  height: 590px;
  display: flex;
  justify-content: center;
  align-items: center;
`
